import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query FormPage($locale: String!, $id: String!, $preview: Boolean) {
    page(locale: $locale, id: $id, preview: $preview) {
      type
      slug
      title
      image
      ingress {
        json
      }
      subtitle
      metaTitle
      metaDescription
      description {
        json
      }
      desktopImage {
        ...contentfulAsset
      }
      mobileImage {
        ...contentfulAsset
      }
    }
  }
`);
